import React from 'react';

import {makeStyles} from '@material-ui/styles'
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import SignInFrom from "../components/sign-in-form";


function SignIn() {

    const classes = useStyles();

    return (
        <Container className={classes.root}>
            <Grid container fixed justifyContent="center">
                <Grid item xs={10} sm={8} md={6}>
                    <SignInFrom/>
                </Grid>
            </Grid>
        </Container>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(5, 'auto')
    },

}));

export default SignIn;
